import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Tag from '../../../../components/presentation/Tag'
import Tooltip from '../../../../components/helpers/Tooltip'
import Text from '../../../../packages/kiti/components/presentation/Text'

const ReplyWarnTags = ({ reply }) => {
  const { t } = useTranslation('common')
  const { value, length, notes, photos } = reply.validations || {}

  const isRequired = notes.required || value.required || photos.required
  const isRequiredValid = notes.valid && value.valid && photos.valid

  if (!isRequired && !length.min && !value.hasMinValue && !value.hasMaxValue && !reply.error) return false

  const requiredColor = !isRequiredValid ? COLORS.red : COLORS.light3
  const minLengthColor = !length.valid ? COLORS.red : COLORS.light3
  const minValueColor = !value.isMinValid ? COLORS.red : COLORS.light3
  const maxValueColor = !value.isMaxValid ? COLORS.red : COLORS.light3

  return (
    <FlexGrid justify="flex-start" gutter={0.2}>
      {!!length.min && (
        <FlexCol>
          <Tag label={t('minimum', { count: length.min })} color={minLengthColor} transparent small />
        </FlexCol>
      )}
      {isRequired && (
        <FlexCol>
          <Tag label={t('required')} color={requiredColor} transparent small />
        </FlexCol>
      )}
      {value.hasMinValue && (
        <FlexCol>
          <Tag label={t('minimum', { count: value.min })} color={minValueColor} transparent small />
        </FlexCol>
      )}
      {value.hasMaxValue && (
        <FlexCol>
          <Tag label={t('maximum', { count: value.max })} color={maxValueColor} transparent small />
        </FlexCol>
      )}

      {reply.error && reply.error === 'insufficient_amount' && (
        <FlexCol>
          <Tooltip actionContent={<Tag label={t('error')} color={COLORS.red} transparent small />}>
            <Text>{t('insufficientAmount')}</Text>
          </Tooltip>
        </FlexCol>
      )}

      {reply.error && reply.error === 'value_lte_zero' && (
        <FlexCol>
          <Tooltip actionContent={<Tag label={t('error')} color={COLORS.red} transparent small />}>
            <Text>{t('valueMustBeGreaterThanZero')}</Text>
          </Tooltip>
        </FlexCol>
      )}

      {reply.error && reply.error === 'error' && (
        <FlexCol>
          <Tag label={t('error')} color={COLORS.red} transparent small />
        </FlexCol>
      )}
    </FlexGrid>
  )
}

export default ReplyWarnTags
